"use client"

import React, { memo } from "react"
import { useDataAttributes } from "../../hooks"
import { BaseInteractiveProps } from "../../utils"
import { Toggle } from "../shadcn/toggle"

/**
 * @description 토글 버튼. 눌린/안눌린 상태를 전환하는 버튼
 * @example
 * <TToggle selected={isActive} onChange={setIsActive}>Bold</TToggle>
 */
interface TToggleProps extends BaseInteractiveProps {
	/** 토글 버튼의 값 (폼 제출 시 사용) */
	value?: string | number | readonly string[]
	/** 토글 버튼 색상 테마. "default"=기본, "line"=외곽선 스타일 */
	color?: "default" | "line"
	/**
	 * 버튼 크기
	 * @ai-style xsmall=24px높이, small=32px높이, medium=40px높이, large=48px높이
	 */
	size?: "xsmall" | "small" | "medium" | "large"
	/** 현재 눌린(활성) 상태 */
	selected: boolean
	/** 버튼 내부 콘텐츠 (텍스트 또는 ReactNode) */
	children: string | React.ReactNode
	/** 상태 변경 콜백. pressed=true이면 눌린 상태로 전환 */
	onChange?: (pressed: boolean) => void
}

function TToggleInner(props: TToggleProps) {
	const { value, color, size, selected, disabled = false, className, dataAttributes, children, onChange, ...restProps } = props
	const dataProps = useDataAttributes(dataAttributes)

	return (
		<Toggle value={value} color={color} size={size} pressed={selected} disabled={disabled} className={className} {...restProps} {...dataProps} onPressedChange={onChange}>
			{children}
		</Toggle>
	)
}

TToggleInner.displayName = "TToggle"

export const TToggle = memo(TToggleInner)
